import { React } from '../Imports';
import { SplitClient } from '@splitsoftware/splitio-react';
import { getSplitConfig, TypedSplitFactory } from '../utilities/split-io-sdk';
import { ConfigService } from '../state/ConfigFreezerService';

interface SplitIOWrapperProps {
    contactedAt: string;
    fleetId: string;
    createdById: string;
    children: React.ReactNode;
}

const SplitIOWrapper = (props: SplitIOWrapperProps) => {
    const splitConfig = getSplitConfig(props.contactedAt, props.fleetId, props.createdById);
    return (
        <TypedSplitFactory
            config={splitConfig}
            updateOnSdkReady={true}
            updateOnSdkReadyFromCache={true}
            updateOnSdkTimedout={true}
            updateOnSdkUpdate={false}
        >
            <SplitClient
                splitKey={ConfigService.getSplitClientKey()}
                updateOnSdkReady={true}
                updateOnSdkReadyFromCache={true}
                updateOnSdkTimedout={true}
                updateOnSdkUpdate={false}
            >
                <>{props.children}</>
            </SplitClient>
        </TypedSplitFactory>
    );
};

export default SplitIOWrapper;
